import {Injectable} from '@angular/core';
import {TableInfo} from '../../../models/tableInfo';

@Injectable({
  providedIn: 'root'
})
export class InfoStore {
  tablesInfo: TableInfo[];

  constructor() {
    this.tablesInfo = [];
  }

  loadInfo(tablesInfo: TableInfo[]) {
    this.tablesInfo = tablesInfo;
  }

  updateInfo(toUpdate: TableInfo) {
    const index = this.tablesInfo.indexOf(toUpdate);
    this.tablesInfo[index].info = toUpdate.info;
  }
}
